import { eTipoPermissao } from '@/enums/ePermissoes';

// Módulo "Estrutura do PDI" (Subsistema A: moldes do questionário — Estrutura, Escalas e Assinaturas).
// A sigla no título é a nomenclatura configurável (token {pdiSigla}, padrão "PDI"), resolvida pelo
// menu/breadcrumb via pdinomenclatura.service — mesmo mecanismo do Res. 4256.
export default [
  {
    description: '{pdiSigla} — Estrutura',
    path: '/educacaoinclusiva/pdi-estrutura',
    name: 'pdi_estrutura',
    component: () => import('@/views/educacaoinclusiva/pdi-estrutura/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.NOVO_PDI_ESTRUTURA_2300100153],
    },
    goesToMenu: true,
  },
];
